import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { PurchaseOrderPurchaseAllocation } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderPurchaseAllocationService extends TmsWebBaseEditCreateService<
  PurchaseOrderPurchaseAllocation,
  PurchaseOrderPurchaseAllocation
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PurchaseOrderPurchaseAllocation', $localize`Purchase Order Purchase Allocation`);
  }

  // The API's Allocate wants the LINE and the REQUIREMENT it is being linked to. This used to post
  // `purchaseOrderLineId` twice (once per letter case), so the requirement id never arrived and
  // the API linked the line to an empty Guid.
  allocate(purchaseOrderLineId: string, purchaseOrderLineRequirementId: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      purchaseOrderLineId,
      purchaseOrderLineRequirementId,
    });
  }

  updatePurchaseOrderPurchaseAllocation(purchaseOrderPurchaseAllocationId: string, quantity: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdatePurchaseOrderPurchaseAllocation`, {
      purchaseOrderPurchaseAllocationId,
      quantity,
    });
  }

  getAllocations(purchaseOrderLineId: any): Observable<PurchaseOrderPurchaseAllocation[]> {
    return this.httpService.get<PurchaseOrderPurchaseAllocation[]>(
      `${this.apiUrl}/GetAllocations?purchaseOrderLineId=${purchaseOrderLineId}`,
    );
  }
}
